import React, { useState, useEffect } from 'react';
import './Signin.css';
import { FaLock } from 'react-icons/fa';
import { MdAdminPanelSettings } from "react-icons/md";
import { RiAdminLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';

const baseURL = process.env.BASE_URL || "";

const SuperAdminSignin = () => {
  const [formData, setFormData] = useState({
    superadminId: '',
    name: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${baseURL}/api/auth/signin/superadmin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          superadminId: formData.superadminId.trim(),
          name: formData.name.trim(),
          password: formData.password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.msg || 'Login failed');
      }

      // Save superAdminId to localStorage
      localStorage.setItem('superAdminId', data.superAdminId); // adjust key if backend gives token instead

      navigate('/superadmin/dashboard');
    } catch (err) {
      console.log(err);
      
      setMessage(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-box-register">
      <form onSubmit={handleSubmit}>
        <div className="form-box">
          <h1>SIGN IN</h1>

          <div className="input-box">
            <input
              type="text"
              name="superadminId"
              placeholder="Super Admin ID"
              value={formData.superadminId}
              onChange={handleChange}
              required
            />
            <RiAdminLine className="icon" />
          </div>

          <div className="input-box">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <MdAdminPanelSettings className="icon" />
          </div>

          <div className="input-box">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <FaLock className="icon" />
          </div>

          <div className="remember-forgot">
            <label>
              <input type="checkbox" required /> I agree to the terms & conditions
            </label>
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>

          {message && (
            <p className={`message ${message.includes('success') ? 'success' : 'error'}`}>
              {message}
            </p>
          )}
        </div>
      </form>
    </div>
  );
};

export default SuperAdminSignin;
